<template>
  <div class="container">

    <div class="content">
      <span class="text1">注销申请提交后，7天后账号将自动注销，请认真阅读以下提醒：</span>
      <span class="text2">
        <span class="text-tag">重要</span>
        为防止误操作，请再次确认是否注销帐号并确认注销后的影响。在此善意提醒，注销帐号为不可恢复的操作，
        建议在最终确定注销前自行备份本帐号相关的所有信息，并请再次确认与帐号相关的所有服务均已进行妥善处理。
        注销帐号后将无法再使用本帐号或找回本帐号浏览、关注、添加、绑定的任何内容或信息（即使你使用相同的手机号码再次注册并使用闪易APP），
        包括但不限于：
      </span>
      <span class="text3">
        1 .本帐号的个人资料和历史信息（包括头像、用户、发布内容、浏览记录、关注、收藏等）都将无法找回
      </span>
      <span class="text3">
        2 .你将无法登录、使用本帐号
      </span>
      <span class="text3">
        3 .通过本帐号使用、授权登录或绑定本帐号后使用的闪易或第三方服务的相关记录将无法找回。你将无法再登录，使用上述服务，
        你曾获得的虚拟权益等财产性利益视为你自动放弃，将无法继续使用。你理解并同意，闪易无法协助你重新恢复上述服务
      </span>
    </div>

    <div class="bottom">
      <div @click="cancelPrivacy" class="btn-cancel">放弃</div>
      <div @click="showCheckDialog" class="btn-confirm">确认注销</div>
    </div>

    <div v-if="showCheck" class="dialog">
      <div class="content">
        <div class="title">注销账号</div>
        <div class="text">若确认注销，七天后你的账号将被注销，同时手机号、第三方授权释放</div>
        <div class="bottom">
          <div @click="dismissCheckDialog" class="btn-cancel">取消</div>
          <div @click="confirmDialog" class="btn-confirm">确认注销</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/privacy";
import {autoCloseWindow, logout} from "../../util/jsbridge";

export default {
  name: "AuthCenter",
  data() {
    return {
      code: '',
      showCheck: false
    };
  },
  mounted() {
    this.code = this.$route.query.code
    window.scroll(0,0)
  },
  methods: {
    showCheckDialog() {
      this.showCheck = true
    },
    dismissCheckDialog() {
      this.showCheck = false
    },
    cancelPrivacy() {
      autoCloseWindow()
    },
    confirmDialog() {
      api.plogout({code: this.code}).then(response => {
        if (response.result === 0) {
          logout('您已注销')
          autoCloseWindow()
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.container {
  background-color: white;
  min-height: 100vh;
  position: relative;
}

.content {
  display: flex;
  flex-direction: column;
  padding: 4vw 4vw 26.7vw 4vw;

  .text1 {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    margin-bottom: 1.3vw;
  }

  .text-tag {
    padding: 1vw;
    font-size: 12px;
    font-weight: 400;
    color: white;
    line-height: 17px;
    background-color: #D83737;
  }

  .text2 {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 26px;
    margin-bottom: 2.7vw;
  }

  .text3 {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    margin-bottom: 2.7vw;
  }
}

.bottom {
  height: 13.3vw;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 1.6vw 0 rgba(0, 0, 0, 0.1);

  .btn-cancel {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50vw;
    height: 100%;
    color: #333333;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    background-color: white;
  }

  .btn-confirm {
    background-color: #286EFF;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50vw;
    height: 100%;
    color: white;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
  }
}

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 81.3vw;
    height: 53.3vw;
    background-color: white;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    border-radius: 1.6vw;

    .title {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      line-height: 18px;
      margin-top: 6.7vw;
      margin-bottom: 5.3vw;
    }

    .text {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
      margin: 0 5.3vw 0 5.3vw;
    }

    .bottom {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;

      .btn-cancel {
        width: 50%;

      }

      .btn-confirm {
        width: 50%;
        border-radius: 0 0 1.6vw 0;
      }
    }
  }
}
</style>
